<template>
  <bilancio-saldi />
</template>

<script>
import BilancioSaldi from '@/components/ask/pages/tesoreria/BilancioSaldi.vue'

export default {
  name: 'PageTesoreriaBilancioSaldi',

  components:{
    BilancioSaldi
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
